// OIDC Configuration for AWS Cognito — values come from environment variables.
// Set VITE_COGNITO_* in .env (local) or your CI/CD environment for each deployment target.

import { WebStorageStateStore } from 'oidc-client-ts';

export const cognitoAuthConfig = {
  authority: import.meta.env.VITE_COGNITO_AUTHORITY,
  client_id: import.meta.env.VITE_COGNITO_CLIENT_ID,
  redirect_uri: window.location.origin + "/callback",
  response_type: "code",
  scope: import.meta.env.VITE_COGNITO_SCOPES,
  post_logout_redirect_uri: window.location.origin,
  automaticSilentRenew: true,
  loadUserInfo: true,
  // Use localStorage so tokens persist across tabs and page refreshes.
  // The default (sessionStorage) is tab-isolated, which causes redirect to /login
  // when opening a link in a new tab even though the user is already signed in.
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};

// Cognito hosted-UI domain used for logout redirects.
export const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN;
